'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ArrowLeft, FileQuestion, Home } from 'lucide-react';
import { useSetBreadcrumbLeaf } from '@/components/layout/BreadcrumbLeafContext';

// Global 404. Rendered inside the shell for any notFound() (e.g. a stale
// investigator slug) or unmatched route. Overriding the breadcrumb leaf keeps a
// bad URL segment from being parsed into a fake name (e.g. "Hector Asdsadsadasd")
// — the slug still shows in the browser address bar (that is the browser, not
// us), but the page itself stays a clean 404. No sensitive data is exposed: the
// slug is whatever the visitor already typed/clicked.
export default function NotFound() {
	const router = useRouter();
	useSetBreadcrumbLeaf('No encontrado');

	return (
		<div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 px-6 py-16 text-center">
			<span className="flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-slate-400">
				<FileQuestion size={30} />
			</span>

			<div className="space-y-1.5">
				<p className="text-5xl font-bold tracking-tight text-slate-300">404</p>
				<h1 className="text-xl font-semibold text-slate-800">Página no encontrada</h1>
				<p className="mx-auto max-w-md text-sm text-slate-500">
					La página que buscas no existe, se movió o el enlace ya no es válido.
				</p>
			</div>

			<div className="mt-1 flex flex-wrap items-center justify-center gap-3">
				<button
					type="button"
					onClick={() => router.back()}
					className="inline-flex items-center gap-2 rounded-[10px] border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
				>
					<ArrowLeft size={16} />
					Volver atrás
				</button>
				<Link
					href="/"
					className="inline-flex items-center gap-2 rounded-[10px] bg-slate-800 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-900"
				>
					<Home size={16} />
					Ir al inicio
				</Link>
			</div>
		</div>
	);
}
